import { render, staticRenderFns } from "./ModificarAvl.vue?vue&type=template&id=cea9f5f2&scoped=true"
import script from "./ModificarAvl.vue?vue&type=script&lang=js"
export * from "./ModificarAvl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea9f5f2",
  null
  
)

export default component.exports